export enum OVERLAY_INTERNAL_EVENTS {
  OPEN_OVERLAY = 'OPEN_OVERLAY',
  CLOSE_OVERLAY = 'CLOSE_OVERLAY',
  UPDATE_OVERLAY = 'UPDATE_OVERLAY',
}

export enum TESTDATA_MODAL {
  OPEN_RUNTIME_VARIABLE = 'OPEN_RUNTIME_VARIABLE',
  CLOSE_RUNTIME_VARIABLE = 'CLOSE_RUNTIME_VARIABLE',
  SELECTED_RUNTIME_VARIABLE = 'SELECTED_RUNTIME_VARIABLE',

  OPEN_PARAMETER = 'OPEN_PARAMETER',
  CLOSE_PARAMETER = 'CLOSE_PARAMETER',
  SELECTED_PARAMETER = 'SELECTED_PARAMETER',

  OPEN_DATA_GENERATOR = 'OPEN_DATA_GENERATOR',
  CLOSE_DATA_GENERATOR = 'CLOSE_DATA_GENERATOR',
  SELECTED_DATA_GENERATOR = 'SELECTED_DATA_GENERATOR',

  OPEN_ENVIRONMENT = 'OPEN_ENVIRONMENT',
  CLOSE_ENVIRONMENT = 'CLOSE_ENVIRONMENT',
  SELECTED_ENVIRONMENT = 'SELECTED_ENVIRONMENT',

  OPEN_MAILBOX = 'OPEN_MAILBOX',
  CLOSE_MAILBOX = 'CLOSE_MAILBOX',
  SELECTED_MAILBOX = 'SELECTED_MAILBOX',

  OPEN_PHONE_NUMBER = 'OPEN_PHONE_NUMBER',
  CLOSE_PHONE_NUMBER = 'CLOSE_PHONE_NUMBER',
  SELECTED_PHONE_NUMBER = 'SELECTED_PHONE_NUMBER',

  OPEN_UPLOAD = 'OPEN_UPLOAD',
  CLOSE_UPLOAD = 'CLOSE_UPLOAD',
  SELECTED_UPLOAD = 'SELECTED_UPLOAD',

  }
